import AccountAPI from '../../api/account_api';
import fetchHookFactory from './fetchHookFactory';

export const [useOrgs] = fetchHookFactory(async () => AccountAPI.getOrgs(), 'always-refresh');
